import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          // Primary Colors - Matching design system
          primary: '#667eea', // Primary blue
          secondary: '#764ba2', // Primary purple
          accent: '#f6d365', // Gold accent

          // Semantic Colors
          error: '#f5576c',
          info: '#4facfe',
          success: '#43e97b',
          warning: '#fda085',

          // Surface Colors
          background: '#f8f9fa',
          surface: '#ffffff',

          // Text Colors
          'on-primary': '#ffffff',
          'on-secondary': '#ffffff',
          'on-background': '#111827',
          'on-surface': '#111827',
        },
      },
      dark: {
        colors: {
          // Primary Colors - Matching design system
          primary: '#667eea',
          secondary: '#764ba2',
          accent: '#f6d365',

          // Semantic Colors
          error: '#f5576c',
          info: '#4facfe',
          success: '#43e97b',
          warning: '#fda085',

          // Surface Colors
          background: '#1a1a2e',
          surface: '#16213e',

          // Text Colors
          'on-primary': '#ffffff',
          'on-secondary': '#ffffff',
          'on-background': '#f9fafb',
          'on-surface': '#f9fafb',
        },
      },
    },
  },
})
